import { Link } from "react-router-dom";
import ReactPlayer from "react-player/file";

export const Introduction = () => {
    return (
        <main className="flex flex-col items-start gap-3 pt-28 w-[85%] m-auto">
            <h2 className="text-8xl">
                Introduction
            </h2>
            <div className="mb-5 max-w-5xl w-full h-full">
                <ReactPlayer
                    url="https://www.dropbox.com/scl/fi/p9xoclckxbcn32wa6ygw5/1-Welcome.mp4?rlkey=gtccladqszb1n6gdi89t1qphp&raw=1"
                    playing
                    controls
                    className='react-player'
                    width="100%"
                    height="100%"
                />
            </div>
            <Link to="/flow/intro" className="yellow-cta">
                Next
            </Link>
        </main>
    )
}